const draftstarsTheme = require('./draftstarsTheme');

module.exports = {
  build: {
    files: {
      imageDir: 'draftstars'
    },
    meta: {
      title: 'Draftstars',
      url: 'https://www.draftstars.com.au/lobby',
      maskIcon: {
        color: '#ff114f',
        href: '/safari-pinned-tab.svg'
      }
    },
    scripts: [
      {
        src: 'https://secure.ewaypayments.com/scripts/eCrypt.js'
      },
      {
        src: 'https://www.googletagservices.com/tag/js/gpt.js',
        async: true
      }
    ]
  },
  app: {
    default: {
      settings: {
        ads: false,
        availableBonuses: [],
        // blogUrl: 'https://blog.draftstars.com.au/',
        appLinks: [
          {
            type: 'ios',
            imageUri: '/images/ios-store.svg',
            href: 'https://itunes.apple.com/au/app/draftstars-afl-nrl-fantasy/id1109446849?mt=8'
          },
          {
            type: 'android',
            imageUri: '/images/android-download.png',
            href: 'https://www.draftstars.com.au/howtodownload'
          }
        ],
        sentry: {
          dsn:
            'https://0f606e2b264a5ea42593c08165aa1efc@o4508016273195008.ingest.us.sentry.io/4510084542955521',
          authToken:
            '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'
        },
        chatURI: 'https://chat.sportsfantasyhq.com/',
        chatExtraChannels: [
          // removed but left as an example in case we need another extra channel:
          // {
          //   id: 'parks',
          //   name: 'Parks',
          //   icon: 'icon-parks',
          //   slug: 'parks'
          // }
        ],
        content: {
          howToPlay: {
            bannerDesktop: '/images/howtoplay/desktop/banner.png',
            bannerMobile: '/images/howtoplay/mobile/banner.png',
            pages: [
              {
                title: 'Meet Draftstars',
                description:
                  "Draftstars adds a whole new dimension to the excitement of live sport. We've taken all the best parts of sports betting, Supercoach and AFL Fantasy (Dreamteam) and packaged this into one exhilarating daily sports competition. Best of all, by choosing a contest you can challenge for the huge cash prizes on offer every day. Playing Draftstars is simple. Here are three steps to get you started.",
                videoUri: '/images/howtoplay/starter_guide.mp4'
              },
              {
                title: 'Step 1: Choose your\u00A0contest',
                description:
                  'Are you ready to play your favourite fantasy sports and win prizes at the same time? Go to the lobby, filter by sport and choose your contest!',
                desktopImages: [
                  '/images/howtoplay/desktop/step1.png',
                  '/images/howtoplay/desktop/step1@2x.png'
                ],
                mobileImages: [
                  '/images/howtoplay/mobile/step1.png',
                  '/images/howtoplay/mobile/step1@2x.png'
                ],
                frame: true
              },
              {
                title: 'Step 2: Select your\u00A0players',
                description:
                  "Create your lineup of players while staying within the salary cap. Which players are in good form? Who is due for a big game? What's your selection strategy?",
                desktopImages: [
                  '/images/howtoplay/desktop/step2.png',
                  '/images/howtoplay/desktop/step2@2x.png'
                ],
                mobileImages: [
                  '/images/howtoplay/mobile/step2.png',
                  '/images/howtoplay/mobile/step2@2x.png'
                ],
                frame: true
              },
              {
                title: 'Step 3 - Watch and Win!',
                description:
                  'This is where the excitement really starts! Your players accrue points based on their real life performance. Make sure you keep an eye on the live leaderboard as you climb to number&nbsp;one!',
                desktopImages: [
                  '/images/howtoplay/desktop/step3.png',
                  '/images/howtoplay/desktop/step3@2x.png'
                ],
                mobileImages: [
                  '/images/howtoplay/mobile/step3.png',
                  '/images/howtoplay/mobile/step3@2x.png'
                ],
                frame: true
              }
            ]
          }
        },
        copyright: '© 2020 PlayUp Interactive Pty Ltd. All Rights Reserved.',
        darkMode: true,
        displayComboCalculator: true,
        displayFantasyInsider: true,
        displayGamblingHelp: true,
        displayGlobalLeaderboard: false,
        displayLoadLineup: true,
        displayLobbyBanner: true,
        displayTop8: true,
        displayPoweredByPlayUp: true,
        displayUserQuestions: false,
        displayMyTeams: true,
        displayTraining: false,
        displayVerificationLink: true,
        displayJackpotSlots: false,
        displayRapidFire: true,
        displayCreateH2H: true,
        enableAccountLimit: true,
        enableFantasyInsider: true,
        enableMobileVerification: true,
        enableUploadLineup: true,
        externalLinks: [
          {
            url: 'https://playbook.playup.com.au/dfs/',
            label: 'PLAYBOOK',
            icon: 'icon_menu_playup'
          }
        ],
        feedbackUri: 'https://draftstars.canny.io/',
        hasH2H: true,
        hasLightBackground: true,
        hasNightMode: true,
        multiEntry: true,
        mustVerifyPhoneToEnterPaidChallenge: false,
        filters: {
          theme: 'light',
          complexity: true,
          entrants: true,
          fee: true,
          payout: true,
          size: false,
          entrantsOptions: [2, 6, 10, 20, 50, 100, 500, null],
          feeOptions: [0, 1, 2, 5, 10, 15, 20, 50, 200, 500]
        },
        hasMultiplierPayout: true,
        locale: 'au-draftstars',
        logoImage: '/images/logo-header-new.png',
        mobileHeaderImage: '/images/logo-header-new.png',
        onesport: false,
        onesportPlatform: 2,
        partnerLinks: [],
        promo: [
          {
            desktopSrc: '/images/carousel-desktop/drop1.jpg',
            mobileSrc: '/images/carousel-mobile/drop1.jpg'
          }
        ],
        rewriteRules: {
          '/challenge': '/contest',
          '/enter-additional-challenges': '/enter-additional-contests',
          '/live-challenges': '/live-contests',
          '/my-challenges': '/my-contests',
          '/rapidfire/challenge': '/rapidfire/contest',
          '/training/challenge': '/training/contest'
        },
        secondaryLinks: [
          {
            title: 'About',
            items: [
              {
                type: 'route',
                href: '/about',
                name: 'About',
                category: 'more',
                icon: 'icon_menu_about'
              },
              {
                type: 'route',
                href: '/gamble-responsibly',
                name: 'Gamble Responsibly',
                category: 'more',
                icon: 'icon_menu_gamble_responsibly'
              },
              {
                type: 'external',
                href: 'https://corporate.playup.com',
                name: 'Corporate Website',
                category: 'more',
                icon: 'icon_menu_corporate_website'
              }
            ]
          },
          {
            title: 'Help',
            items: [
              {
                type: 'route',
                href: '/contact-us',
                name: 'Contact Us',
                category: 'more',
                icon: 'icon_menu_contact'
              },
              {
                type: 'route',
                href: '/how-to-play',
                name: 'How to Play',
                category: 'more',
                icon: 'icon_menu_how_to_play'
              },
              // {
              //   type: 'route',
              //   href: '/rules',
              //   name: 'Rules',
              //   category: 'more',
              //   icon: 'icon_menu_rules',
              // },
              {
                type: 'external',
                href: 'https://www.draftstars.com.au/improve-your-dfs-game-with-draftstars-coach/',
                name: 'Draftstars Coach',
                category: 'more',
                icon: 'icon_menu_draftstars_coach'
              },
              {
                type: 'route',
                href: '/faqs',
                name: 'FAQs & Rules',
                category: 'more',
                icon: 'icon_menu_faqs'
              }
            ]
          }
          // {
          //   title: 'More',
          //   items: [
          //     {
          //       type: 'route',
          //       href: '/terms',
          //       name: 'Terms & Conditions',
          //       category: 'more',
          //       icon: 'icon_menu_terms_conditions'
          //     },
          //     {
          //       type: 'route',
          //       href: '/privacy-policy',
          //       name: 'Privacy Policy',
          //       category: 'more',
          //       icon: 'icon_menu_privacy_policy'
          //     }
          //   ]
          // }
        ],
        siteName: 'Draftstars',
        social: {
          enableChallengeSocialShare: false,
          messages: {
            enteredAndOpen: "I've entered this contest, come join me!",
            enteredAndInProgress:
              "If you're not first, you're last! Check out the Live Leaderboard!",
            enteredAndCompleted:
              'Run and won. What a game! Check out the Leaderboard to see who cashed in!',
            notEntered: 'No excuses, play like a champion!'
          },
          twitterUrl: 'https://twitter.com/DraftstarsAU',
          facebookUrl: 'https://www.facebook.com/draftstarsau/',
          twitterVia: 'DraftstarsAU'
        },
        stateFieldType: 'select',
        paymentMethods: [
          {
            label: 'Credit Card',
            value: 'credit'
          }
        ],
        defaultPaymentMethod: 'credit'
      },
      theme: draftstarsTheme.theme,
      skin: draftstarsTheme.skin
    },
    development: {
      settings: {
        onesportSource: 'https://onesport-api.playup.io',
        configName: 'development',
        dataSource: 'https://draftstars-staging-api.sportsfantasyhq.com',
        verificationUri: 'https://draftstars-content.sportsfantasyhq.com/verification',
        siteUrl: 'https://draftstars.sportsfantasyhq.com'
      }
    },
    staging: {
      configName: 'staging',
      chatURI: 'https://chat.sportsfantasyhq.com',
      settings: {
        googleTagManagerId: 'GTM-P4CZC4J4',
        onesportSource: 'https://onesport-api.playup.io',
        dataSource: 'https://draftstars-staging-api.sportsfantasyhq.com',
        verificationUri: 'https://draftstars-content.sportsfantasyhq.com/verification',
        siteUrl: 'https://draftstars.sportsfantasyhq.com',
        // public path used to correctly reference assets, so it doesn't try to load them from the portal url
        bundlePublicUrl: 'https://draftstars-staging.sportsfantasyhq.com'
      }
    },
    ci: {
      settings: {
        dataSource: 'https://draftstars-ci-api.sportsfantasyhq.com',
        onesportSource: 'https://onesport-admin.sportsfantasyhq.com',
        verificationUri: 'https://draftstars-ci-content.sportsfantasyhq.com/verification',
        pxcUrl: 'https://playxchange-sandbox.now.sh',
        pxcPartnerId: '76e014ea-049d-4efe-aa59-54828a2efca9',
        siteUrl: 'https://playup.sportsfantasyhq.com',
        bundlePublicUrl: 'https://draftstars-ci.sportsfantasyhq.com/'
      }
    },
    uat: {
      settings: {
        configName: 'uat',
        chatURI: 'https://chat.sportsfantasyhq.com',
        onesportSource: 'https://push-v2.onesport.org',
        dataSource: 'https://draftstars-staging-api.sportsfantasyhq.com',
        verificationUri: 'https://draftstars-content.sportsfantasyhq.com/verification',
        siteUrl: 'https://draftstars-staging.sportsfantasyhq.com',
        bundlePublicUrl: 'https://draftstars-staging.sportsfantasyhq.com'
      }
    },
    production: {
      settings: {
        configName: 'production',
        chatURI: 'https://newchat.draftstars.com.au',
        onesportSource: 'https://onesport-api.playup.io',
        dataSource: 'https://api2.draftstars.com.au',
        googleTagManagerId: 'GTM-P5BGSR',
        verificationUri: 'https://content.draftstars.com.au/verification',
        siteUrl: 'https://play.draftstars.com.au',
        // public path used to correctly reference assets, so it doesn't try to load them from the portal url
        bundlePublicUrl: 'https://app.draftstars.com.au'
      }
    }
  }
};
